import { Box, Flex, Text } from '@chakra-ui/react';
import { BrowserView } from 'react-device-detect';
import { BrowserSidebar } from '../component/globalComponents/BrowserSidebar';
import { BrowserTopBar } from '../component/globalComponents/BrowserTopBar';
import { MobileViewPage } from '../component/globalComponents/MobileViewPage';

export const ConductCode = () => {
    const renderContent = () => (
        <Flex className={'privacy-policy'}>
            <h1>
                <b>Code of conduct</b>
            </h1>
            <p>Updated on June 13, 2023</p>
            <p>
                Game on! At STREAMSIX, we strive to create a welcoming, fun, and respectful gaming
                environment for all players and streamers.It’s important that everyone feels part of
                a safe, friendly, and fair community while engaging with STREAMSIX games and our
                app.
            </p>
            <p>
                As a STREAMSIX user you agree to conduct yourself in a way that is kind and
                respectful to all users, respect differences, and don’t encourage or take part in
                illegal or illicit activity.
                <b></b>
            </p>
            <p>
                <b></b>
                <br />
            </p>
            <p>
                <b>Commitment to kindness and community</b>
            </p>
            <p>
                Help build community by engaging positively, being respectful and supportive, and
                giving others the benefit of the doubt.Remember that each username is a real person.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>Don’t threaten, hate, bully or harass</b>
            </p>
            <p>
                Don’t engage in any form of abuse, harassment, or bullying towards other people.
                This includes trolling, flaming, spamming, doxing or using threatening, abusive or
                hateful language. Hate speech and personal attacks would be considered a serious
                violation.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>Guideline enforcement and reporting</b>
            </p>
            <p>
                Please understand that STREAMSIX is a diverse community and includes people of many
                backgrounds. While you may not necessarily agree with someone’s point of view, it
                may not be a violation of our code of conduct. However, if you notice or suspect
                hurtful or anti-community behaviour or see something that you feel violates our code
                of conduct, you can us the “contact support” form in the app or email
                help@streamsix.com.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>Account representation and standards</b>
            </p>
            <p>
                Accounts should represent yourself or the online personality you have created and
                own the rights to. Do not create an account impersonating someone else or using fake
                information (name, email address, date of birth, etc).
            </p>
            <p>
                Don’t Create inappropriate usernames or avatars, including names containing
                profanity, sexual references, or hate speech.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>Fair play</b>
            </p>
            <p>
                We’re committed to fair play, and we’re pretty sure you are too. Don’t participate
                in activities such as cheating, hacking, botting, boosting, or tampering that
                provides unfair advantages to you or your teammates, or negatively impacts the
                experience of other players.
            </p>
            <p>Don’t do anything that disrupts the flow of gameplay or community.</p>
            <p>
                <br />
            </p>
            <p>
                <b>User generated content (UGC)</b>
            </p>
            <p>
                You have the right to share any UGC you have produced using STREAMSIX games,
                services and software provided you do not misrepresent our games or services, and
                you’re responsible for making sure that your content doesn’t violate any laws.{' '}
                <b> </b>
            </p>
            <p>
                You give STREAMSIX and partners the right to use your publicly posted UGC you create
                using STREAMSIX software or products, including UGC featuring your image or likeness
                and if your UGC features another person in it you’re responsible for making sure you
                have their permission to feature them
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>Harmful and illegal activities</b>
            </p>
            <p>
                Don’t use your presence on STREAMSIX to commit any crimes, online or offline. Your
                account cannot be used to facilitate harmful or illegal activities. This includes
                advocating, threatening, or showing you causing harm to yourself, other people or
                animals. Don’t promote illegal activities such as property crime, distribution of
                illegal weapons, or drug manufacturing. While we aren’t responsible for links or
                offline behaviour, if your account is directing to a channel or website that
                promotes these illegal or harmful behaviours it will be suspended.
            </p>
            <p>
                <br />
            </p>
            <p>
                We don’t allow accounts that might try to collect money for an illegal purpose, or
                that encourage others to break the law. You may not use your bio, direct messaging
                or links posted to STREAMSIX to promote illegal activity.
            </p>
            <p>
                <br />
            </p>
            <p>
                STREAMSIX has zero tolerance for behaviors that hurt or exploit minors. Users
                actively facilitating exploitation or attempting to exploit minors will be removed.
                We will report all users engaging in such activity to appropriate authorities upon
                removal.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>Fraud</b>
            </p>
            <p>
                Don’t use your STREAMSIX presence to commit fraud including unauthorized use of
                family or friends' accounts, credit card theft or identity theft and chargeback
                schemes.
            </p>
            <p>
                Don’t violate our rules regarding STREAM CASH, STREAM GOLD or any other currency
                used on STREAMSIX platforms or in our games.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>Updates to STREAMSIX terms of service and code of conduct</b>
            </p>
            <p>
                STREAMSIX has the right to update terms of service and the code of conduct at any
                time. It is your responsibility to stay current on community guidelines, you can
                refer to the date at the top of this page to see when our code of conduct was most
                recently updated.If you have any questions please contact help@streamsix.com.
            </p>
            <p>
                <b></b>
            </p>
            <p>
                <b>Respect for other’s ideas and intellectual property</b>
            </p>
            <p>
                Please respect the ideas and creation of others and STREAMSIX. Don’t claim others’
                ideas, identities or content as your own. Don’t misuse the intellectual property of
                STREAMSIX.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>How we enforce these guidelines</b>
            </p>
            <p>
                Violations of the code of conduct are taken seriously, and consequences of breaking
                this code depend on the severity of the issue and the frequency a user violates this
                code.
            </p>
            <p>
                Consequences will vary between warnings, suspension of a streamer’s status as a
                “streamer of good standing”, andaccount suspension. In extreme cases, with activity
                that may violate laws, STREAMSIX will cooperate with local authorities.
            </p>
            <p>
                If an account is suspended the STREAMCASH or STREAMGOLD account will be frozen and
                account owners can contact help@streamsix.com regarding access. In instances of
                potentially illegal activity, we may have to cooperate with local authorities
                regarding STREAMCASH and STREAMGOLD access.
            </p>
            <p>
                We are committed to fairness, and will review each issue on a case-by-case basis. If
                you feel your account was unfairly suspended, please contact us at
                help@streamsix.com.
            </p>
            <p>
                <b>
                    If you have any questions about anything in this code, please reach out to us at
                    help@streamsix.com
                </b>
            </p>
        </Flex>
    );

    return (
        <>
            <BrowserView>
                <BrowserTopBar color="#FFF" isLoading={false}>
                    <Box className={'settings-title browser-view-title'}>
                        <Text>CODE OF CONDUCT</Text>
                    </Box>
                </BrowserTopBar>
                <BrowserSidebar />
                <Flex className={'browser-content'}>{renderContent()}</Flex>
            </BrowserView>
            <MobileViewPage
                title="CODE OF CONDUCT"
                titleColor="#FFF"
                titleBackgroundColor="#6867dd"
                isLoading={false}
            >
                <Flex className={'privacy-mobile'}>{renderContent()}</Flex>
            </MobileViewPage>
        </>
    );
};
